<template>
    <div>
      <v-dialog v-model="open" persistent width="900">
        <v-card color="#3cbc62" dark>
          <v-card-title>
            <v-row justify="center">
              <v-col class="text-h5 text-bold" cols="auto">
                Por favor aguarde um momento...
              </v-col>
            </v-row>

            <v-progress-linear
              indeterminate
              color="white"
              class="mb-4"
            ></v-progress-linear>
          </v-card-title>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
export default {
  props: {
    open: Boolean,
  },
};
</script>

